<script setup></script>

<template>
  <main class="home">
    <div class="home__container">
      <!-- <h1>This is the Home Page</h1> -->
    </div>
  </main>
</template>

<style scoped lang="scss">
@use './home.scss';
</style>
